import { render, staticRenderFns } from "./infodata.vue?vue&type=template&id=f3dea4b4&scoped=true&"
import script from "./infodata.vue?vue&type=script&lang=js&"
export * from "./infodata.vue?vue&type=script&lang=js&"
import style0 from "./infodata.vue?vue&type=style&index=0&id=f3dea4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dea4b4",
  null
  
)

component.options.__file = "infodata.vue"
export default component.exports